// components/Pagination.tsx
import React from "react";
import { Pagination } from "../../models/general.model";

interface Props {
  pagination: Pagination;
  onPageChange: (page: number) => void;
}

const MIN_TO_SHOW = 4;

const AppPagination: React.FC<Props> = ({ pagination, onPageChange }) => {
  const { page, pages, total } = pagination;

  // Solo muestra paginación cuando supera el mínimo
  if (total <= MIN_TO_SHOW) return null;

  const getPages = (): (number | "...")[] => {
    if (pages <= 5) return Array.from({ length: pages }, (_, i) => i + 1);
    if (page <= 3) return [1, 2, 3, 4, 5, "...", pages];
    if (page >= pages - 2) return [1, "...", pages - 4, pages - 3, pages - 2, pages - 1, pages];
    return [1, "...", page - 1, page, page + 1, "...", pages];
  };

  return (
    <div className="d-flex justify-content-end mt-4">
      <ul className="pagination">
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => onPageChange(page - 1)}>
            &laquo;
          </button>
        </li>
        {getPages().map((p, i) =>
          p === "..." ? (
            <li key={`ellipsis-${i}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
              <button className="page-link" onClick={() => onPageChange(p as number)}>
                {p}
              </button>
            </li>
          ),
        )}
        <li className={`page-item ${page === pages ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => onPageChange(page + 1)}>
            &raquo;
          </button>
        </li>
      </ul>
    </div>
  );
};

export default AppPagination;
